const tableHead = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '角色名称'
  },
  dataIndex: 'name',
  align: 'center'
}, {
  slots: {
    title: '状态'
  },
  dataIndex: 'status',
  scopedSlots: {
    customRender: 'status'
  },
  align: 'center'
}, {
  slots: {
    title: '添加时间'
  },
  dataIndex: 'createAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: 330
}];
import { mapState } from 'vuex';
import standardTable from '@/components/standardTable/index';
import { getRoleTable, deleteRoleTable, roleStatus } from '@/api/roleManage';
import roleModel from './roleModel';
export default {
  name: 'roleManage',
  components: {
    standardTable,
    roleModel
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentRow: null,
      dialogVisible: false,
      tableHead,
      name: '',
      status: undefined,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  computed: {
    ...mapState({
      tagList: state => state.tagsView.tagList
    })
  },
  created() {
    this.getRoleTable();
  },
  methods: {
    //新增
    handleAdd() {
      this.currentRow = null;
      this.dialogVisible = true;
    },
    getRoleTable() {
      getRoleTable({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.name,
        status: this.status
      }).then(res => {
        this.tableData = res.items || [];
        this.pagination.total = res.totalNum;
      });
    },
    handleEdit(row) {
      this.currentRow = {
        ...row
      };
      this.dialogVisible = true;
    },
    handleOk() {
      this.dialogVisible = false;
      this.currentRow = null;
      this.getRoleTable();
    },
    //删除
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该角色'), {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        deleteRoleTable({
          roleId: val.id
        }).then(() => {
          _this.$message.success(_this.$t('删除成功'));
          _this.getRoleTable();
        });
      });
    },
    checkedFun(val) {
      if (!this.isAuth('home.roleStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      roleStatus({
        roleId: val.id,
        status: val.status == 0 ? 1 : 0
      }).then(res => {
        this.$message.success(this.$t('操作成功'));
        val.status = val.status == 0 ? 1 : 0;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getRoleTable();
    }
  }
};